import React from "react";
import Input from "../../../Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
const activestatus = [
  { id: "1", label: "Yes", value: 1 },
  { id: "0", label: "No", value: 0 },
];

const DepartmentFrom = ({
  mode = "I",
  onSubmit,
  show = false,
  handleClose,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useFormContext();
  console.log(errors);
  return (
    <Modal show={show} onHide={handleClose} animation={true} centered>
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>{mode === "I" ? "Add Department" : "Edit Department"}</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          <div className="form-row">
            <div className="mb-3">
              <Input
                name="description"
                label="Deparment Name"
                placeholder="Deparment Name"
                className={`form-control ${
                  errors.description ? "is-invalid" : ""
                }`}
                labelClassName="form-label"
                type="text"
                required={true}
              />
            </div>
            <div className="mb-3">
              <Input
                name="isActive"
                type="commonSelect"
                placeholder="Active Status"
                className={`form-control ${
                  errors.isActive ? "is-invalid" : ""
                }`}
                label="Active Status"
                labelClassName="form-label"
                optionData={activestatus}
                required={true}
                requiredMessage="Active Status is required"
                onChange={(selectedOption) => {
                  console.log(selectedOption);
                  setValue("isActive", selectedOption);
                  trigger("isActive");
                }}
                defaultValue={watch("isActive")}
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="submit" className="btn btn-primary">
              {mode === "I" ? "Add" : "Update"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

DepartmentFrom.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default DepartmentFrom;

// import React from "react";
// import Input from "../../../Components/UI/Input";
// import { useFormContext } from "react-hook-form";
// import PropTypes from "prop-types";

// const activestatus = [
//   { id: "1", label: "Yes", value: 1 },
//   { id: "0", label: "No", value: 0 },
// ];

// const DepartmentFrom = ({ mode = "I", onSubmit }) => {
//   const {
//     handleSubmit,
//     formState: { errors },
//     watch,
//     trigger,
//     setValue,
//   } = useFormContext();

//   console.log(errors)

//   return (
//     <>
//       <div>
//         <div className="modal fade" id="department-from">
//           <div className="modal-dialog modal-dialog-centered custom-modal-two">
//             <div className="modal-content">
//               <div className="page-wrapper-new p-0">
//                 <div className="content">
//                   <div
//                     className="modal-header border-0 custom-modal-header"
//                     style={{
//                       justifyContent: "space-between",
//                     }}
//                   >
//                     <div className="page-title">
//                       <h4>
//                         {mode === "I" ? "Add Department" : "Edit Department"}
//                       </h4>
//                     </div>
//                     <button
//                       type="button"
//                       className="close"
//                       data-bs-dismiss="modal"
//                       aria-label="Close"
//                     >
//                       <span aria-hidden="true">×</span>
//                     </button>
//                   </div>
//                   <div className="modal-body custom-modal-body">
//                     <form onSubmit={handleSubmit(onSubmit)}>
//                       <div className="mb-3">
//                         <Input
//                           name="description"
//                           label="Deparment Name"
//                           placeholder="Deparment Name"
//                           className={`form-control ${
//                             errors.description ? "is-invalid" : ""
//                           }`}
//                           labelClassName="form-label"
//                           type="text"
//                           required={true}
//                         />
//                       </div>
//   <div className="mb-0">
//     <Input
//       name="isActive"
//       type="select"
//       placeholder="Active Status"
//       className={` ${errors.isActive ? "is-invalid" : ""}`}
//       label="Active Status"
//       labelClassName="form-label"
//       optionData={activestatus}
//       required={true}
//       requiredMessage="Active Status is required"
//       onChange={(selectedOption) => {
//         setValue(
//           "isActive",
//           selectedOption ? selectedOption.value : null
//         );
//         trigger("isActive");
//       }}
//       defaultValue={watch("isActive")}
//     />
//   </div>
//                       <div className="modal-footer-btn">
//                         <button
//                           type="button"
//                           className="btn btn-cancel me-2"
//                           data-bs-dismiss="modal"
//                         >
//                           Cancel
//                         </button>
//                         <button type="submit" className="btn btn-submit">
//                           Save
//                         </button>
//                       </div>
//                     </form>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
// DepartmentFrom.propTypes = {
//   mode: PropTypes.string.isRequired,
//   onSubmit : PropTypes.func.isRequired
// };

// DepartmentFrom.defaultProps = {
//   mode: "I",
// };

// export default DepartmentFrom;
